export const workSchema = {
  '@context': 'https://schema.org/',
  '@type': 'HowTo',
  name: 'How Sikka Works',
  description:
    'Steps by step process on how to start earning money with sikka app daily with ease and refer your friends to earn more. Sign up Now to earn money.',
  image: 'https://sikkaapp.in/how-it-works',
  step: [
    {
      '@type': 'HowToStep',
      text: 'You can install the application from the Google Play Store or Sikka’s official website.',
      image: 'https://sikkaapp.in/how-it-works',
      name: 'Install the app',
      url: 'https://sikkaapp.in/how-it-works'
    },
    {
      '@type': 'HowToStep',
      text: 'Verify your mobile number and email address to be a verified user on Sikka .',
      image: 'https://sikkaapp.in/how-it-works',
      name: 'Complete the verification',
      url: 'https://sikkaapp.in/how-it-works'
    },
    {
      '@type': 'HowToStep',
      text: 'Set up a user profile by adding details on the Sikka app for a better user experience.',
      image: 'https://sikkaapp.in/how-it-works',
      name: 'Build your profile',
      url: 'https://sikkaapp.in/how-it-works'
    },
    {
      '@type': 'HowToStep',
      text: 'After the setup is complete, you can enjoy the perks of Sikka by earning daily cash.',
      image: 'https://sikkaapp.in/how-it-works',
      name: 'Enjoy the benefits',
      url: 'https://sikkaapp.in/how-it-works'
    },
    {
      '@type': 'HowToStep',
      text: 'Gain as many Sikkas as possible in multiple ways and fill your Sikka wallet with rewards.',
      image: 'https://sikkaapp.in/how-it-works',
      name: 'Get multiple ways to earn',
      url: 'https://sikkaapp.in/how-it-works'
    },
    {
      '@type': 'HowToStep',
      text: 'Gain rewards from exciting offers and redeem your daily earnings from the Sikka  wallet.',
      image: 'https://sikkaapp.in/how-it-works',
      name: 'Earn and redeem exciting rewards',
      url: 'https://sikkaapp.in/how-it-works'
    },
    {
      '@type': 'HowToStep',
      text: 'Transfer your daily earnings straight from your Sikka  wallet into your bank accounts. You can transfer your Sikka coins to your bank account through UPI.',
      image: 'https://sikkaapp.in/how-it-works',
      name: 'Redemption policy',
      url: 'https://sikkaapp.in/how-it-works'
    }
  ]
};
